<template>
  <div v-if="lineItemData.length > 0">
    <b-table :items="lineItemData" :fields="fields" :key="updateUI" show-empty>
      <template #cell(index)="data">
        <div>{{ data.index + 1 }}</div>
      </template>
      <template #cell(sku)="data">
        <div>{{ data.item.itemInstance.moreInformation.sku }}</div>
      </template>
      <template #cell(name)="data">
        <div>{{ getNameProduct(data.item) }}</div>
      </template>
      <template #cell(quantity)="data">
        <div class="price">{{ data.item.quantity }}</div>
      </template>
      <template #cell(unitPrice)="data">
        <div class="price">{{ formatMoneyNotUnit(divisionThousand(data.item.unitPrice)) }}</div>
      </template>
      <template #cell(totalAmount)="data">
        <div>{{ formatMoneyNotUnit(divisionThousand(data.item.totalAmount)) }}</div>
      </template>

      <template #row-details="data">
        <!--Chọn số EMEI/se-ri: useImeiAndSerial-->
        <div class="line dataUseImeiAndSerial" v-if="data.item.useImeiAndSerial">
          <div class="col-md-2 text-bold pull-left mt-2">IMEI/Serial:</div>
          <div class="col-md-10 pull-left selectDT">
            <div class="select-item" v-for="(item, i) in JSON.parse(data.item.lineItemOtherInfo.seriesNo)" :key="i">
              {{item}}
            </div>
          </div>
        </div>

        <!--Chọn số Lo/HSD: useProductBatch-->
        <div class="line dataUseProductBatch" v-if="data.item.useProductBatch">
          <div class="col-md-2 text-bold pull-left mt-2">Lô HSD:</div>
          <div class="col-md-10 pull-left selectLoHsd">
            <div>
              <div class="select-item" v-for="(itemBatch, indexBatch) in data.item.batchTmp" :key="indexBatch">
                {{ itemBatch.batchCode }} - HSD: {{ convertDateItem(itemBatch.expirationDate) }} - SL:
                {{ itemBatch.quantityVal }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-table>

    <!-- loading -->
    <div class="box-loading" v-if="loading">
      <div class="loading">
        <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "table-order-information",
  // props: ["lineItem"],
  props: {
    lineItem: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      lineItemData: JSON.parse(JSON.stringify(this.lineItem)),
      updateUI: 1,
      loading: false,

      fields: [
        {
          key: "index",
          label: "#",
          thStyle: { width: "1%", maxWidth: "20px" },
        },
        {
          key: "sku",
          label: "Mã SKU",
          thStyle: { width: "4%",  minWidth: "150px" },
        },
        {
          key: "name",
          label: "Tên phiên bản sản phẩm",
          thStyle: { width: "4%", minWidth: "250px" },
        },
        {
          key: "quantity",
          label: "Số lượng",
          thStyle: { width: "1%" },
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "unitPrice",
          label: "Đơn giá",
          thStyle: { width: "4%" },
          thClass: "text-right",
          tdClass: "text-right",
        },

        {
          key: "totalAmount",
          label: "Thành tiền",
          thStyle: { width: "4%" },
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],

    };
  },
  methods: {
    getNameProduct(item) {
      if(item && item.itemInstance && item.itemInstance.moreInformation && item.itemInstance.moreInformation.name) {
        let result = item.itemInstance.moreInformation.name.trim()
        if (result) return result
      }
      return item.itemInstance.name
    }
  }
};
</script>

<style lang="scss" scoped>
.price {
  background-color: #ddd;
  padding: 16px 12px;
  border-radius: 4px;
}
.pointed-none {
  pointer-events: none;
}
.select-item {
    display: inline-block;
    background-color: #F2F3F4;
    padding: 6px;
    margin: 0 10px 10px 10px;
    border-radius: 4px;
}
</style>
